'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class MenuItemComponent {
    subItemsShowed = false;

    constructor($scope, $state, $rootScope, LeftNav) {
        'ngInject';
        const vm = this;

        this.leftNavSelected = LeftNav.selected;
        this.$state = $state;
        this.$rootScope = $rootScope;


        // LISTENERS

        this.$rootScope.$on('leftnav.menuItem.setInactive', function (event, data) {
            if (data.state) {
                if (data.state != vm.data.state) {
                    vm.active = false;
                    vm.subItemsShowed = false;
                    vm.$onInit();

                }
            } else if (data.slug) {
                if (data.slug != vm.data.slug) {
                    vm.active = false;
                    vm.subItemsShowed = false;
                    vm.$onInit();
                } else {

                }
            }
        });

    }

    $onInit() {
        this.initData();
    }

    $onChanges = (bindings) => {
        // //bindings.selected.currentValue.state == bindings.selected.currentValue.state
        // if (bindings.data.currentValue.slug && (bindings.data.currentValue.slug == bindings.data.currentValue.slug)) {
        //   this.active = true;
        // }
        // if (bindings.data.currentValue.slug && (bindings.data.currentValue.slug == bindings.data.currentValue.slug)) {
        //   this.active = true;
        // }
    }

    initData() {
        // this.active = this.$state.includes(this.data.state + '.*');
    }

    menuAction(data) {
        let vm = this;
        if (data.children && data.children.length) {
            const subItemsShowedCopy = angular.copy(this.subItemsShowed);
            this.$rootScope.$broadcast('leftnav.menuItem.setInactive', data);
            this.subItemsShowed = !subItemsShowedCopy;
        } else {
            this.$rootScope.$broadcast('leftnav.menuItem.setInactive', data);
            this.$state.go(data.state, null, vm.data.stateOptions);
        }
    }

    //
    // $onChanges = changes => {
    //  console.log(changes);
    // };
}

export default angular.module('directives.leftnav', [])
    .component('menuItem', {
        template: require('./menu-item.pug'),
        controller: MenuItemComponent,
        controllerAs: 'vm',
        bindings: {
            data: '<',
            selected: '<'
        }
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/leftnav/menu-item/menu-item.component.js